import { Navigate, useLocation } from "react-router";

import type { CryptoSide } from "./CryptoPage";

/**
 * `/crypto-deposits` and `/crypto-withdrawals` became tabs of `/crypto`.
 * Redirect, carrying the search string through: the params those links hold
 * (`?tab=history&status=admin_declined`, `?item=<id>`, `?address=<addr>`) are
 * the whole reason someone bookmarked or pasted one.
 */
export function LegacyCryptoRedirect({ side }: { side: CryptoSide }) {
  const { search } = useLocation();
  return <Navigate to={`/crypto/${side}${search}`} replace />;
}
